import React, { useState, MouseEvent } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { requestStatusProps } from "../../../../utils/types";
import { AxiosError } from "axios";

interface AuthButtonProps {
    id : number,
    str_arr : string
    onSubmit : (stat : requestStatusProps) => void;
    endpoint : string
}

const AuthUpdateButton : React.FC<AuthButtonProps> = ({id, str_arr, onSubmit, endpoint}) => {
    
    const [loading, setLoading] = useState<boolean>(false);

    function updatePriv (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        setLoading(true);
        setTimeout(async()=>{
            try{
                await api.put(endpoint+id, {
                    arr_str : str_arr
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setLoading(false);
                onSubmit({
                    success : true,
                    message : 'Page access updated!'
                })
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    onSubmit({
                        success : false,
                        message : 'Unauthorized access!'
                    })
                }else{
                    onSubmit({
                        success : false,
                        message : 'An error occured!'
                    })
                }
                setLoading(false);
            }
        },500);
    }

    return (
        <>
        {loading ? (
            <button type="button" disabled className='button button-disabled w-auto'>
                <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
            </button>
        ) : (
            <button type="button" onClick={updatePriv} className="button button-vcc-primary w-auto">
                Update
            </button>
        )}
        </>
    );
}

export default AuthUpdateButton;